import { composeIO } from 'react-compose-io'
import { itemTransformacaoApiIO } from './ItemTransformacaoApi.IO'
import { ItemTransformacaoApiView } from './ItemTransformacaoApi.View'

export const ItemTransformacaoApi = composeIO(ItemTransformacaoApiView, itemTransformacaoApiIO)
